// exported for testing
export function wrapInDelimiters(tex: string): string {
    return "\\[" + tex + "\\]";
}
